import React from 'react';
import { Modal } from './base-ui/Modal';
import { Button } from './base-ui/Button';

/**
 * Modal shown when user has been idle for too long.
 * Offers options to continue the session or disconnect.
 */
export function IdleWarningModal({
  open,
  secondsLeft,
  onStayConnected,
  onDisconnect,
}) {
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const timeDisplay = minutes > 0
    ? `${minutes}:${seconds.toString().padStart(2, '0')}`
    : `${seconds}s`;

  return (
    <Modal
      open={open}
      onClose={onStayConnected}
      title="Are you still there?"
      width="max-w-md"
      preventBackdropClose
      showCloseButton={false}
    >
      <div className="text-center space-y-6">
        <p className="text-lg text-gaia-text-dim">
          You've been inactive for a while. Your session will be paused in{' '}
          <span className="font-bold text-gaia-primary">{timeDisplay}</span>{' '}
          to save resources.
        </p>

        <div className="flex gap-4 justify-center">
          <Button
            onClick={onStayConnected}
            variant="primary"
            size="lg"
            className="min-w-32"
          >
            I'm here
          </Button>
          <Button
            onClick={onDisconnect}
            variant="secondary"
            size="lg"
            className="min-w-32"
          >
            Disconnect
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default IdleWarningModal;
